$(document).ready(function() {

    // $('.image-swatches').flickity({
    //     // options
    //     cellAlign: 'left',
    //     contain: true,
    //     setGallerySize: false
    // });

  setTimeout(function() { console.log('class remove');
     $('.ProductListWrapper .ProductItem  .ProductItem__Label ').removeClass('hide');
  }, 2000);

    $(document).on('change click','.ProductItem .ColorSwatch__Radio', function() {
        var $this = $(this)
        var img = $this.data('imgsrc')
console.log('click');
        var parent = $this.parents('.ProductItem')
        var childs = $(parent).find('.swatch-item')
        var sel = $(parent).find(`.swatch-item[data-imgsrc="${img}"]`).data('index') - 1
        var slider = $(parent).find('.image-swatches')
        var sizes = $(parent).find('span.size-opt')
        var size = $(parent).find('span.size-opt.active').text()
        var swatches = $this.val()
        var dropdown = $(parent).find(".varselect")

        $(sizes).removeClass('dis-size')
        $(dropdown).find('option').removeAttr('selected')

        $(dropdown).find($(`option[data-title="${ swatches + ' / ' + size }"]`)).attr('selected','selected')
        $(dropdown).find($(`option[data-title="${size + ' / ' + swatches }"]`)).attr('selected','selected')
       

        // Price change
        var price_max_container = $(parent).find('.Price--highlight')
        var price_min_container = $(parent).find('.Price--compareAt')
        var discount_value = $(parent).find('.ProductItem__Label--onSale')
        var price_min = $(dropdown).find('option:selected').data('compare-price')
        var price_max = $(dropdown).find('option:selected').data('price')
        var variant_url = $this.data('variant-url')
        var image_link = $(parent).find('.ProductItem__ImageWrapper')
        var title_link = $(parent).find('.ProductItem__Title a')


      console.log('price_min',price_min)
      console.log('price_max',price_max)
      console.log('price_min_container',price_min_container)
      console.log('price_max_container',price_max_container)
      
     
        $(price_min_container).text(price_min)
        $(price_max_container).text(price_max)
        $(image_link).attr("href", variant_url)
        $(title_link).attr("href", variant_url)
       //console.log('discount_value',discount_value)
      

      if(price_min == '')
      {
         console.log('in if');
        //$(discount_value).text(`0% OFF`)
        $(discount_value).css('display','none');
        $(price_max_container).addClass('not-on-sale');
      }else
      {
         console.log('in else')
        $(discount_value).css('display','block');
         $(price_max_container).removeClass('not-on-sale');
        if(discount_value !== undefined) {
          $(discount_value).text(`${Math.round((parseInt(price_min.replaceAll(",", "")) - parseInt(price_max.replaceAll(",", ""))) * 100 / parseInt(price_min.replaceAll(",", "")))}% OFF`)
        }
      }
        // $(parent).find('span.size-opt').removeClass('dis-size')

        // childs.removeClass('is-vis')
        // sel.addClass('is-vis')
        // slider.flickity('destroy')
        var $carousel = $(slider).flickity()
        $carousel.flickity( 'selectCell', sel ); 
        console.log(sel)

        $carousel.flickity('resize');
            var act = $(dropdown).find(`option[data-opt1="${swatches}"],option[data-opt2="${swatches}"]`)
            console.log(swatches);
            console.log(size);
 
            var sizeOut = $(parent).find(`.size-opt`)

            $(act).each( function() {
                var el = $(this)
                var size1 = $(el).data('opt1')
                var size2 = $(el).data('opt2')

                if ( size1.length != 0 && el.data('stock') == false ) {
                    var disabled = $(parent).find(`.size-opt[data-size="${size1}"]`)
                    $(disabled).addClass('dis-size')
                }

                if ( size2.length != 0 && el.data('stock') == false ) {
                    var disabled = $(parent).find(`.size-opt[data-size="${size2}"]`)
                    $(disabled).addClass('dis-size')
                }
            })


            $(parent).find('.prod-hovs').addClass('showed')
      let swatch_list = $(this).closest('.ProductItem').find('.sizes-sw ul li');
      let count = 0;

      swatch_list.each(function(){
        if($(this).find('.size-opt').hasClass('dis-size')){
          count = count + 1;
        }
        
        $(this).closest('.ProductItem').find('.cus-show-soldout').addClass('cus-hide-soldout');
        if(swatch_list.length == count ){
         $(this).closest('.ProductItem').find('.cus-show-soldout').removeClass('cus-hide-soldout');
        }
        
      });
    });

$(document).ready(function(){
   // setTimeout(function(){
    $('.ProductList .Grid__Cell').each(function(){
        $(this).find('.ProductItem__ColorSwatchList').find(':checked').trigger('change');
        $(this).find('.ProductItem__Info .prod-hovs').removeClass('showed');
    });
  // },2000)   
});

    $(document).on( 'click', '.ProductItem__Wrapper .atc-text', function() {
      	
        var parent = $(this).parents('.ProductItem ')
        var sizes = $(parent).find('.prod-hovs')
        var size = $(parent).find('span.size-opt.active').text()
        var swatches  = $(parent).find('.ColorSwatch__Radio:checked').val()
        var dropdown = $(parent).find(".varselect")
        var size_opts = $(parent).find('span.size-opt')
		
        
        console.log("latest:"+swatches);
      	$(parent).find('.ColorSwatch__Radio:checked').trigger( "click" );
      
//         $(size_opts).removeClass('dis-size')
        
//         $(dropdown).find('option').removeAttr('selected')

//         $(dropdown).find($(`option[data-title="${ swatches + ' / ' + size }"]`)).attr('selected','selected')
//         $(dropdown).find($(`option[data-title="${size + ' / ' + swatches }"]`)).attr('selected','selected')
        

//         $(price_min_container).text(price_min)
//         $(price_max_container).text(price_max)

//             var act = $(dropdown).find(`option[data-opt1="${swatches}"],option[data-opt2="${swatches}"]`)
//             console.log(size)
 
//             var sizeOut = $(parent).find(`.size-opt`)

//             $(act).each( function() {
//                 var el = $(this)
//                 var size1 = $(el).data('opt1')
//                 var size2 = $(el).data('opt2')

//                 if ( size1.length != 0 && el.data('stock') == false ) {
//                     var disabled = $(parent).find(`.size-opt[data-size="${size1}"]`)
//                     $(disabled).addClass('dis-size')
//                 }

//                 if ( size2.length != 0 && el.data('stock') == false ) {
//                     var disabled = $(parent).find(`.size-opt[data-size="${size2}"]`)
//                     $(disabled).addClass('dis-size')
//                 }
//             })
        
//         $(sizes).addClass('showed')
    })

    $(document).on( 'click', 'span.size-opt', function(el) {

        var parent = $(this).parents('.ProductItem ')
        var size = $(this).text()
        var form = $(parent).find('.adder-form')
        var stockout = $(parent).find('.prod-hovs .out-error')
        var dropdown = $(parent).find(".varselect")
        var swatches  = $(parent).find('.ColorSwatch__Radio:checked').val()
	
        $(this).removeClass('red')
        $(stockout).hide()

        console.log(swatches)
        $(dropdown).find(`option`).removeAttr('selected')

        $(dropdown).find($(`option[data-title="${ swatches + ' / ' + size }"]`)).attr('selected','selected')
        $(dropdown).find($(`option[data-title="${size + ' / ' + swatches }"]`)).attr('selected','selected')

        // Price change
        var price_max_container = $(parent).find('.Price--highlight')
        var price_min_container = $(parent).find('.Price--compareAt')
        var price_min = $(dropdown).find('option:selected').data('compare-price')
        var price_max = $(dropdown).find('option:selected').data('price')

        $(price_min_container).text(price_min)
        $(price_max_container).text(price_max)

        console.log(form.find('.varselect option:selected').val())

        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
            data: {
                quantity: 1,
                id: form.find('.varselect').val()
            },
            dataType: 'json', 
            success: function (data) { 
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true   
                }));
                document.querySelector('[data-drawer-id="sidebar-cart"][data-action="open-drawer"]').click() 
            },
            error: function (data) { 
                $(stockout).show()
                $(el).addClass('red')
                $(this).addClass('dis-size')
            } 
        }) 

        $(parent).find('span.size-opt').removeClass('active')
        $(this).addClass('active')
    })



    // var flkty = new Flickity( '.image-swatches', {
    //     cellAlign: 'left',
    //     contain: false,
    //     pageDots: false
    // });

    $('.color_selector').on('change',function() {
        var color = $(this).val()

        $('label.SizeSwatch').removeClass('crossed-out');

        crossOuter(color)
    })


    if ($('.color_selector:checked').length > 0 ) {
        var color = $('.color_selector:checked').val()
        crossOuter(color)
    }
    
    function crossOuter(i) {
        $(`.crossouter option[disabled][data-color="${i}"],.crossouter option[disabled][data-size="${i}"]`).each( function() {
            var $this = $(this);
            var dropSize = $this.data('size');
            var dropColor = $this.data('color');

            $('label.SizeSwatch[data-val="'+ dropSize + '"]').removeClass('crossed-out')
            $('label.SizeSwatch[data-val="' + dropColor + '"]').removeClass('crossed-out')
            
            $('label.SizeSwatch[data-val="' + dropSize + '"]').addClass('crossed-out')
            $('label.SizeSwatch[data-val="' + dropColor + '"]').addClass('crossed-out')
        })
    }
});
var slideInit = function() {
    $('.image-swatches:not(.flickity-enabled)').each( function(i,e) {
        var flkty = new Flickity( e, JSON.parse(e?.dataset.flickity));
    })
   $('.ProductListWrapper .ProductItem  .ProductItem__Label ').removeClass('hide');
  

   $(".ProductList.ProductList--grid  .Grid__Cell" ).each(function( index ) {
      console.log('index',index);
      var discText = $(this).find('.ProductItem__Label.ProductItem__Label--onSale.saleOff').text();
      console.log('discText',discText);
       if(discText.indexOf('\n                  0% OFF\n                ') != -1){
          console.log( " found");
           $(this).find('.ProductItem__Wrapper .ProductItem__Label.ProductItem__Label--onSale.saleOff').css('display','none');
           $(this).find('.Price--highlight').addClass('not-on-sale');
      }
      
   });
   
  
 
  
}
document.addEventListener("DOMContentLoaded", function() {

    // $('.ProductItem').each( function(i,e) {
    //     var $this = $(this);
    //     //    var selectedColor = $(this).find('.ColorSwatch__Radio:checked').val()
    //     var dropdown = $this.find(".varselect")
    //     var activeColor = $this.find('.ColorSwatch__Radio:checked').val()

    //        setTimeout( function() {
    //             var act = $(dropdown).find('option')

    //             $(act).each( function(i,size) {
    //                 var el = this;
    //                 var sizes = el.data('size')
    //                 var title = el.data('title')

    //                 if ( sizes == false ) {
    //                     var dis = $(el).data('opt1')
    //                     var sizeOut = $(el).find(`[data-size="${dis}"]`)
    //                     $(sizeOut).addClass('dis-size')
    //                 }
    //             })
    //         }, 100)
    // })
    
    if ( $('#Huratips-Pagination').length ) {
        var endlessScroll = new Ajaxinate({
            container: '.ProductList--grid',
            pagination: '#Huratips-Pagination',
            callback: slideInit
        });
    }

    jQuery('.swatch-item:not(.is-vis)').show()


});

$(window).on('load', function() {
    jQuery('.swatch-item:not(.is-vis)').show()
})